import {keyframes} from "@emotion/react";
import styled from "@emotion/styled";
import {mq} from "@styles/helpers";
import {Devices} from "@styles/tokens";


export const NumberRollContainer = styled.div<{show:boolean}>`
   display:flex;
   justify-content: center;
   width:100%;
   opacity: ${props => props.show?1:0}!important;
   transition: opacity 200ms ease-in-out!important;
   span{

       font-size: 42px;
       font-weight: 700;
       color:#FEB445;
    }
`;
